import CryptoJS from 'crypto-js';


export const decrypt = (input, key) => {
    let result = '';
    for (let i = 0; i < input.length; i++) {
        // XOR each character with the key
        result += String.fromCharCode(input.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return result;
}

export const decrypt2 = (ciphertext, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedString
};

export const cryptoEncryptForWebOTP = async () => {
    let ciphertext = JSON.stringify({
        keyString: new Date().toString(),
        secretKey: process.env.REACT_APP_OTP_TOKEN_SECRET_KEY
    })


    const bytes = CryptoJS.AES.encrypt(ciphertext, process.env.REACT_APP_OTP_TOKEN_PASS_KEY);
    const decryptedString = bytes.toString()

    return decryptedString
}
